export const GET_COMMON_KEYWORDS = 'get-common-keywords';
export const GET_ALL_COMMON_KEYWORDS = 'get-all-common-keywords';
export const GET_PROJECT_KEYWORDS = 'get-project-keywords';
export const GET_KEYWORD_DOMAINS = 'get-keyword-domains';
export const GET_KEYWORD_STATS_RECOMPUTE = 'get-keyword-stats-recompute';
